<template>
  <ValidationObserver @submit="updateWeightage">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      :disable-position-center="true"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span class="capitalize">
          Edit Weighatge for
          {{ resultTitle }}
        </span>
      </template>
      <template v-slot>
        <InputFieldWrapper>
          <InputBox
            v-model="resultDetails['weightage']"
            type="text"
            name="WEIGHTAGE"
            title="WEIGHTAGE"
            label="WEIGHTAGE"
            placeholder="WEIGHTAGE"
            rules="required"
          />
        </InputFieldWrapper>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>Update</span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import { Form as ValidationObserver } from 'vee-validate'
import { mapActions, mapState } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import { objectDeepCopy } from '@utils/generalUtil'
import UIButton from '@src/components/UiElements/UIButton.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiModalContainer,
    InputBox,
    ValidationObserver,
    Loader,
    UIButton,
    InputFieldWrapper,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: () => {},
    },
    assignment: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  data() {
    return {
      isLoading: false,
      resultDetails: {},
    }
  },
  computed: {
    resultTitle() {
      return this.assignment
        ? this.resultDetails?.assignment?.title
        : this.resultDetails?.subject_exam_schedule?.exam_schedule?.title
    },
  },
  created() {
    this.resultDetails = objectDeepCopy(this.result)
  },
  methods: {
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('toggle')
          break
      }
    },
    async updateWeightage() {
      this.isLoading = true
      let payload = {
        result: this.resultDetails,
        id: this.resultDetails.id,
      }
      let [res, err] = this.assignment
        ? await this.updateSubjectAssignmentWeightage(payload)
        : await this.updateSubjectResultWeightage(payload)
      if (err) this.isLoading = false
      else this.$emit('toggle', true)
    },
    ...mapActions('exams', ['updateSubjectResultWeightage', 'updateSubjectAssignmentWeightage']),
  },
}
</script>
